import { Route, Routes as RouterRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import AuthRoute from "../../components/AuthRoute";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";
import routes from "./routes";
import { REPORT_SECTIONS } from "./utils";

const SENTRY_MODULE_TAGS = {
  [REPORT_SECTIONS.PDF_GENERATOR]: "pdf-generator",
  [REPORT_SECTIONS.REPORTING]: "reporting",
};

const Reporting = props => {
  const { section = REPORT_SECTIONS.REPORTING } = props || {};
  const moduleTag = SENTRY_MODULE_TAGS[section] || "reporting";

  return (
    <Sentry.ErrorBoundary
      fallback={createModuleErrorBoundary(moduleTag)}
      beforeCapture={scope => {
        scope.setTag("module", moduleTag);
      }}
    >
      <RouterRoutes>
        {routes?.map((item, index) => {
          return (
            <Route
              key={index}
              path={item?.path}
              element={
                <AuthRoute permissions={item.permissions}>
                  <item.element {...props} />
                </AuthRoute>
              }
            />
          );
        })}
      </RouterRoutes>
    </Sentry.ErrorBoundary>
  );
};

export default Reporting;
